import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { Trans, useTranslation } from 'react-i18next';
import IAcceptPrivacyCheckbox from '../interfaces/IAcceptPrivacyCheckbox';

const AcceptPrivacyCheckbox = ({ isPrivacyAccepted, acceptPrivacy } : IAcceptPrivacyCheckbox) => {
  const [translate] = useTranslation();

  return (
    <FormGroup className="accept-privacy-statement d-flex align-items-start">
      <Input
        id="privacy-statement-checkbox"
        name="privacy-statement-checkbox"
        type="checkbox"
        checked={isPrivacyAccepted}
        onChange={acceptPrivacy}
      />
      <Label for="privacy-statement-checkbox" className="ms-2">
        <Trans i18nKey="COMPONENTS.CHECKOUT_CONTAINER.FORM.ACCEPT_PRIVACY_CHECKBOX.AGREE_WITH_TRANS">
          <span>I agree with the </span>
          {' '}
          <a
            href={translate('COMPONENTS.CHECKOUT_CONTAINER.FORM.ACCEPT_PRIVACY_CHECKBOX.PRIVACY_LINK')}
            target="_blank"
            rel="noopener noreferrer"
          >
            privacy statement
          </a>
          {' '}
          and the
          {' '}
          <a
            href={translate('COMPONENTS.CHECKOUT_CONTAINER.FORM.ACCEPT_PRIVACY_CHECKBOX.CONDITIONS_LINK')}
            target="_blank"
            rel="noopener noreferrer"
          >
            terms and conditions
          </a>
          .
        </Trans>
      </Label>
    </FormGroup>
  );
};

export default AcceptPrivacyCheckbox;
